import { render } from "./DirectionRequests.vue?vue&type=template&id=00fa1040"
import script from "./DirectionRequests.vue?vue&type=script&lang=js"
export * from "./DirectionRequests.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__